/**
 * Btn - port 1:1 z new-design/ui.jsx Btn function.
 *
 * Uzywa custom CSS classes: btn, btn--<variant>, btn--<size>, btn--block.
 * Style z legacy.css (port z new-design/styles.css).
 *
 * Variants: ghost (default), primary, secondary, danger, success
 * Sizes: sm, md (default), lg
 */
import type { CSSProperties, MouseEvent, ReactNode } from "react";
import { Icon } from "./Icon";

export type BtnVariant = "ghost" | "primary" | "secondary" | "danger" | "success" | "plan" | "tool" | "current" | "subtle";
export type BtnSize = "sm" | "md" | "lg";

interface BtnProps {
  variant?: BtnVariant;
  size?: BtnSize;
  block?: boolean;
  icon?: string;
  iconR?: string;
  children?: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  style?: CSSProperties;
  type?: "button" | "submit" | "reset";
  title?: string;
  className?: string;
}

export function Btn({
  variant = "ghost",
  size,
  block,
  icon,
  iconR,
  children,
  onClick,
  disabled,
  style,
  type = "button",
  title,
  className,
}: BtnProps) {
  const cls = [
    "btn",
    `btn--${variant}`,
    size && `btn--${size}`,
    block && "btn--block",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      className={cls}
      onClick={onClick}
      disabled={disabled}
      style={style}
      type={type}
      title={title}
    >
      {icon && <Icon name={icon} />}
      {children}
      {iconR && <Icon name={iconR} />}
    </button>
  );
}
